// FuenteBadge — marca una hora que registró la máquina y, si aplica, que
// todavía espera datos de una persona (lote, operarios).
//
// Sin `fuente === 'maquina'` no renderiza nada: las horas manuales se ven
// exactamente como antes. Texto a 12 px (no los 10 px del Badge): se lee en tableta.

import { cn } from '../../lib/utils';
import { Badge } from './badge';
import { Icon } from './icon';

export interface FuenteBadgeProps {
  fuente?: 'manual' | 'maquina' | null;
  pendienteCompletar?: boolean | null;
  className?: string;
}

export function FuenteBadge({ fuente, pendienteCompletar, className }: FuenteBadgeProps) {
  if (fuente !== 'maquina') return null;
  if (pendienteCompletar) {
    return (
      <Badge tone="warn" className={cn('text-xs normal-case tracking-normal', className)}>
        <Icon name="edit" size={11} stroke={2} />
        Pendiente de completar
      </Badge>
    );
  }
  return (
    <Badge tone="info" className={cn('text-xs normal-case tracking-normal', className)}>
      <Icon name="plug" size={11} stroke={2} />
      Desde máquina
    </Badge>
  );
}
